// local
// export const domain = "http://www.nbbch.org:3000/";
export const domain = "https://bedoaibackend.ksta.co/";

// export const domain = "http://www.nbbch.org:3000/";
export const adminDomain = "http://www.nbbch.org:8000/";
